import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { FileLink } from '@/components/ui/FileLink';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const Report: FC<ViewProps> = ({ result, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#report`}>
        <Headding icon={<Edit icon={16} />}>健康診断結果ファイル</Headding>
      </Link>
      <Item>
        <Grid>
          <Dl>
            <Dt>添付ファイル</Dt>
            <Dd>{result.report?.url ? <FileLink file={result.report} /> : displayFormat()}</Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
